import React, { useEffect, useState } from 'react';
import Layout from './layout';
import Api from '../services/api';
import CollectionModel from '../models/collection';
import CollectionImage from './collection-image';
import './scss/collection-image.scss';
import FilterSidebar from './filter-sidebar';
import EmptyView from './empty-view';
import Loader from './loader';
import Error from './error';
import SandraJsAPI from "../services/sandraJsAPI";

function Collections():React.ReactElement {
  const collectionArray: CollectionModel[] = [];
  const [collections, setCollections] = useState(collectionArray);
  const [isLoading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    SandraJsAPI.getCollections()
      .then((response) => {
        if (response.error) {
          setErrorMessage(response.error.message);
        } else {
          setCollections(response.data);
        }
        setLoading(false);
      })
      .catch((reason) => {
        setErrorMessage(reason.message);
        setLoading(false);
      });
  }, []);

  let view = <div />;
  view = (errorMessage) ? (<Error header="Oops! Server says" description={errorMessage} />
  ) : (
    <div className="row flex-nowrap">
      <div className="col-auto">
        <FilterSidebar />
      </div>
      <div className="col  pt-3">
        <div className="container-fluid ps-0">
          <div className="clearfix">
            <span
              data-bs-target="#sidebar"
              data-bs-toggle="collapse"
              aria-expanded="false"
              className="link-hover collapsed"
            >
              <i className="bi bi-list bi-lg py-2 p-1">Filter</i>
            </span>
            <a
              href="/collection?action=add"
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Add new collection"
              className="btn btn-light float-end"
            >
              Add New
            </a>
          </div>
        </div>
        <h3>Collections</h3>
        <div className="mb-5">
          <div>
            {collections?.length === 0 ? <EmptyView title="Ahh! Seems like your collections DB is empty." desc="Please add new collection" /> : (
              <div>
                <div className="row gy-4">
                  {collections?.map((collection) => (
                    <CollectionImage
                      collection={collection}
                    />
                  ))}
                </div>
              </div>
            ) }
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Layout>
      { isLoading ? <div style={{ padding: '5rem', textAlign: 'center' }}><Loader width="70px" imageNumber="0" /></div> : (
        view
      )}
      <div />
    </Layout>
  );
}

export default Collections;
